// import formatPrice from '../utils/formatPrice';
import accounting from 'accounting';

let formatAccounting = function(field, currency) {
    this['form'][field + "_formated"] = accounting.formatMoney(this['form'][field + "_formated"], `${currency} `, 2);
    this['form'][field] = accounting.unformat(this['form'][field + "_formated"]);
}
export default formatAccounting;
